import React, { Component } from 'react'
import { connectForm, Form, Field, Submit, Group, Messages } from '~/form'
import { updateProject } from '../actions'
import { Modal, Button, Header } from 'semantic-ui-react'
import { push } from 'react-router-redux'

class ProjectUpdateContainer extends Component {
  static formSubmit(dispatch, formId, values, changed) {
    dispatch(updateProject(values, formId))
  }

  static formValidation = {
    name: ['required'],
  }

  componentWillMount = () => {
    let { formInit, project } = this.props
    formInit(project)
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, goTo } = this.props
    let projectId = formState.values.get('id')

    return (
      <Modal open dimmer="blurring" size="small">
        <Modal.Header icon="user plus" content="Muokkaa projektia" />
        <Form onSubmit={formSubmit} formState={formState}>
          <Messages formState={formState} />
          <Group>
            <Field label="Projektin nimi" type="text" name="name" onChange={formUpdate} formState={formState} />
            <Field
              label="Organisaatio"
              type="reference"
              referenceConfig={{
                id: 'organization',
                options: { source: 'organization' },
              }}
              name="organization_id"
              onChange={formUpdate}
              formState={formState}
            />
          </Group>
          <Group title="Muistiinpanot">
            <Field
              label="Sisältötoiveet"
              type="wysiwyg"
              name="data.contentWishes"
              onChange={formUpdate}
              formState={formState}
            />
            <Field
              label="Asiakkaan toiveet"
              type="wysiwyg"
              name="data.customerWishes"
              onChange={formUpdate}
              formState={formState}
            />
            <Field label="Muistiinpanot" type="wysiwyg" name="data.notes" onChange={formUpdate} formState={formState} />
          </Group>
          <Group submit>
            <Button as="a" size="tiny" onClick={e => e.preventDefault() & goTo(`/project/${projectId}`)}>
              Peruuta
            </Button>
            <Submit content="Tallenna" color="green" icon="save" />
          </Group>
        </Form>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    project: state.activeProject,
    loading: state.activeProjectLoading,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    goTo: path => dispatch(push(path)),
  }
}

export default connectForm('ProjectUpdate', ProjectUpdateContainer, mapStateToProps, mapDispatchToProps)
